var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"management-tabs__container py-0 pb-16"},[_c('DraftFilter'),(_vm.showDataTable)?_c('DraftData'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }